import '@/composition-api';
import Vue from 'vue';
import VueMeta from 'vue-meta';
import VuePellEditor from 'vue-pell-editor';
import VueTelInput from 'vue-tel-input';
import vueKanban from 'vue-kanban';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import smoothscroll from 'smoothscroll-polyfill';
import VueGtm from 'vue-gtm';
import PortalVue from 'portal-vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import i18n from '@/i18n';
import echo from '@/echo';
import vuetify from '@/plugins/vuetify';
import '@/assets/css/style.scss';
import 'dragula/dist/dragula.min.css';
import '@huntica/huntica-interview-module/src/sass/video-player.scss';
import User from '@/orm/models/User/User';
import Company from '@/orm/models/Company/Company';
import '@/sentry';
import Locale from '@/locale';
import VueQuillEditor from 'quill-vuejs';
import 'quill/dist/quill.snow.css';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

Vue.use(PortalVue);
Vue.use(VueMeta);
Vue.use(VuePellEditor);
Vue.use(VueTelInput);
Vue.use(vueKanban);
Vue.component('VuePhoneNumberInput', VuePhoneNumberInput);
Vue.use(VueReCaptcha, {
  siteKey: process.env.VUE_APP_RECAPTCHA_KEY,
  loaderOptions: {
    autoHideBadge: true,
  },
});
Vue.use(VueQuillEditor);

if (process.env.NODE_ENV === 'production') {
  Vue.use(VueGtm, {
    id: 'GTM-KD6WLKV',
    defer: false,
    enabled: true,
    debug: false,
    loadScript: true,
    vueRouter: router,
  });
}

smoothscroll.polyfill();

const VTab = Vue.component('VTab');
VTab.options.props.ripple.default = false;

Vue.prototype.$echo = echo;
Vue.config.devtools = process.env.VUE_APP_DEV_TOOLS === 'true';

(async () => {
  const skipAuthBootstrap = sessionStorage.getItem('skipAuthBootstrap') === '1';
  if (skipAuthBootstrap) {
    sessionStorage.removeItem('skipAuthBootstrap');
  }

  try {
    if (!skipAuthBootstrap) {
      await User.api().fetch();
      const user = User.getAuthUser();
      if (user) {
        Locale.change(user.settings.locale);
      }
      await Company.api().fetch();
    }
  } catch (e) {
    console.log(e);
  }

  // https://accordev.atlassian.net/browse/HUN-1281
  router.onError((error) => {
    if (/loading chunk \d* failed./i.test(error.message) || /Refused to execute script/i.test(error.message)) {
      window.location.reload();
    }
  });

  new Vue({
    silent: process.env.NODE_ENV === 'production',
    productionTip: process.env.NODE_ENV !== 'production',
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App),
  }).$mount('#app');
})();
